// Human-readable text for Daily's `camera-error` / getUserMedia failures
// (mic/camera permission, missing or busy device).
export function describeDeviceError(error, type) {
  const media = error?.blockedMedia || error?.missingMedia || error?.failedMedia || [];
  const what = media.length === 1 ? (media[0] === "audio" ? "microphone" : "camera") : (type === "video" ? "microphone and camera" : "microphone");
  switch (error?.type) {
    case "permissions":
      return error.blockedBy === "browser"
        ? `Your browser is blocking the ${what}. Allow access in the browser/site settings, then rejoin the call.`
        : `${what[0].toUpperCase()}${what.slice(1)} access was denied. Click the lock icon in the address bar, allow the ${what}, then rejoin the call.`;
    case "not-found":
      return `No ${what} was found. Connect one and rejoin the call.`;
    case "cam-in-use":
    case "mic-in-use":
    case "cam-mic-in-use":
      return `Your ${what} is being used by another app. Close it and rejoin the call.`;
    case "undefined-mediadevices":
      return "This browser can't access your microphone/camera. Use Chrome, Edge, Safari or Firefox over HTTPS.";
    default:
      return `We couldn't access your ${what}. Check your device and rejoin the call.`;
  }
}
